import Vue from 'vue'
import { ACCESS_TOKEN, USER_NAME, USER_INFO, USER_AUTH } from '@/store/variables'
import { plain2Tree } from '@/utils/array'

function res2Router (resList) {
  const routers = []
  let permissions = []
  if (resList) {
    resList.forEach((res) => {
      if (res.type === '2') {
        if (res.permissionCode) {
          permissions.push(res.permissionCode)
        }
        if (res.children && res.children.length > 0) {
          const object = res2Router(res.children)
          permissions = permissions.concat(object.permissions)
        }
        return { routers: routers, permissions: permissions }
      }
      const router = {
        path: res.path,
        component: (resolve) => require(['@/' + res.component + '.vue'], resolve),
        name: res.name,
        meta: { title: res.title, icon: res.icon, noCache: false },
        hidden: res.hidden === '1'
      }
      if (res.active) {
        router.meta.activeMenu = res.active
      }
      if (res.children && res.children.length > 0) {
        if (!res.children.every(r => r.type === '2')) {
          router.redirect = res.redirect ? res.redirect : 'noRedirect'
        }
        const object = res2Router(res.children)
        if (object.routers.length > 0) {
          if (res.children.length === 1 && res.children[0].hidden !== '1') {
            router.alwaysShow = true
          }
          router.children = object.routers
        }
        permissions = permissions.concat(object.permissions)
      }
      routers.push(router)
      if (res.permissionCode) {
        permissions.push(res.permissionCode)
      }
    })
  }
  return { routers: routers, permissions: permissions }
}

const user = {
  stat: {
    token: '',
    username: '',
    nickname: '',
    avatar: '',
    resources: [],
    info: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { username, nickname }) => {
      state.username = username
      state.nickname = nickname
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_RESOURCE: (state, resources) => {
      state.resources = resources
    }
  },
  actions: {
    Login ({ commit }, userInfo) {
      console.log('登陆')
      return new Promise((resolve, reject) => {
        console.log(Vue.$api)
        Vue.$api.user.login(userInfo).then(response => {
          if (response.success) {
            const result = response.data || response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username, nickname: userInfo.nickname })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          } else {
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        const logoutToken = state.token
        commit('SET_TOKEN', '')
        commit('SET_RESOURCE', [])
        Vue.ls.remove(ACCESS_TOKEN)
        sessionStorage.removeItem(USER_AUTH)
        Vue.$api.user.logout(logoutToken).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
    GetPermissions ({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.$api.user.getInfo().then(response => {
          const { resList } = response

          const { permissions } = res2Router(plain2Tree(resList, 'resId', 'parentId', 'children', '0'))
          if (permissions.length === 0) {
            permissions.push('NO_PERMISSION_' + Vue.$utils.generateUUID())
          }
          sessionStorage.setItem(USER_AUTH, JSON.stringify(permissions))
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
